import { useConfiguration } from '@ori/favorites-context';
import { getProductPermissions } from '@ori/favorites-fetching';
import { useSWR } from '@ori/fetching';
import type { Dispatch, SetStateAction } from 'react';

import { useToken } from './useToken';

export interface UseGetProductPermissionsParams {
  allFavoriteProductCodes: string[];
  areFavoriteProductCodesLoaded: boolean;
  isVisible: boolean;
  sourceAppName: string;
  setRemainingProductCodes: Dispatch<SetStateAction<string[]>>;
  setAllowedFavoriteProductCodes: Dispatch<SetStateAction<string[]>>;
  setAreFavoriteProductCodesLoaded: Dispatch<SetStateAction<boolean>>;
  setAreFavoritesLoaded: Dispatch<SetStateAction<boolean>>;
}

export const useGetProductPermissions = ({
  allFavoriteProductCodes,
  areFavoriteProductCodesLoaded,
  isVisible,
  sourceAppName,
  setAllowedFavoriteProductCodes,
  setAreFavoriteProductCodesLoaded,
  setAreFavoritesLoaded,
  setRemainingProductCodes,
}: UseGetProductPermissionsParams) => {
  const { currentLanguage, graphqlUrl, tenant, customerId } = useConfiguration();
  const { token } = useToken();
  useSWR(
    [allFavoriteProductCodes, areFavoriteProductCodesLoaded, isVisible],
    async (productCodes: string[], areProductCodesLoaded: boolean, visible: boolean) => {
      if (!areProductCodesLoaded && productCodes.length && visible && token) {
        const mappedAllowedFavoriteProductCodes = await getProductPermissions({
          currentLanguage,
          graphqlUrl,
          sourceAppName,
          tenant,
          token,
          customerId,
          productCodes,
        });
        setRemainingProductCodes(mappedAllowedFavoriteProductCodes);
        setAllowedFavoriteProductCodes(mappedAllowedFavoriteProductCodes);
        setAreFavoriteProductCodesLoaded(true);
        if (mappedAllowedFavoriteProductCodes.length === 0) {
          setAreFavoritesLoaded(true);
        }
      }
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );
};
